const Joi = require("joi").defaults((schema) => schema.options({
  allowUnknown: true 
}));
export default Joi;